import { createContext, useContext } from "react";
var context = createContext(false);
/**
 * A quick way to conditionally inherit the sticky context within a table.  If
 * the sticky prop was defined and a boolean, it will be used. Otherwise the
 * inherited context value will be used.
 * @private
 */
export function useSticky(sticky) {
    var isSticky = useContext(context);
    return typeof sticky !== "undefined" ? !!sticky : isSticky;
}
/**
 * @private
 */
export var StickyTableProvider = context.Provider;
//# sourceMappingURL=sticky.js.map